import { useCallback, useEffect, useState } from 'react';

export default function SuspendDynamicProps({ Component, ...props }) {
  const [SuspendedComponent, setSuspendedComponent] = useState(null);

  const changeProps = useCallback(async () => {
    await new Promise((resolve) => setTimeout(resolve, props.delay));
    setSuspendedComponent(<Component {...props} />);
  }, [props]);

  useEffect(() => {
    changeProps();
  }, [changeProps]);

  return SuspendedComponent;
}
